export default {
    "msg": {
        "8": "8",
        "20": "20",
        "250": "250",
        "Enter a new password": "Immettere una nuova password",
        "Empty": "空",
        "No data": "Nessun dato",
        "Installation Package List": "Elenco dei pacchetti di installazione",

        "Settings - Profiles": "Impostazioni - Profili",
        "User Management": "Gestione utenti",
        "Operation Records": "Registri delle operazioni",
        "Exit": "Esci",
        "Total pages:": "Pagine totali:",
        "page": "pagina",
        "Go to": "Vai a",
        "Prev": "Precedente",
        "Next": "Avanti",
        "per page": "Ogni pagina",
        "items": "Articolo",
        "Please enter the page number to go to": "Inserisci il numero di pagine",
        "Language": "Lingua",
        "Profile Picture": "Immagine del profilo",
        "Old Password": "Vecchia password",
        "New Password": "Nuova password",
        "Confirm Password": "Conferma password",
        "The two passwords entered do not match": "Le due password inserite non corrispondono",
        "Enter the new password again": "Immettere nuovamente la nuova password.",
        "This must match the new password above": "Deve corrispondere alla nuova password indicata sopra.",
        "Invalid input。Password length must be 8–16 characters": "Input non valido. La lunghezza della password deve essere compresa tra 8 e 16 caratteri",
        "Lenovo Privacy Statement": "l'Informativa sulla privacy Lenovo",
        "Lenovo Software License Agreement": "il contratto di licenza software Lenovo (SLA, Software License Agreement)",
        "Third-Party Notice": "Notifiche di terzi",
        "Third-party notifications":"Notifiche di terze parti",
        "Change Password": "Modifica password",
        "Edit Profile": "Modifica profilo",
        "Exited successfully": "Uscito correttamente",
        "Admin": "amministratore",
        "Common user": "Utente comune",
        "Super Admin":"Superamministratore",
        "Model": "Modello",
        "Are you sure you want to delete this?": "Eliminarlo?",
        "Enter a new password。It must include at least three of the following: uppercase letters, lowercase letters， numbers， and special characters": "Immettere una nuova password.Deve includere almeno tre dei seguenti elementi: lettere maiuscole, lettere minuscole, numeri e caratteri speciali.",
        "It must include at least three of the following: uppercase letters, lowercase letters, numbers,and special characters":"Deve includere almeno tre dei seguenti elementi: lettere maiuscole, lettere minuscole, numeri e caratteri speciali.",
        "Tip": "Suggerimento",
        "Confirm": "Conferma",
        "Cancel": "Annulla",
        "Deletion successful": "Eliminazione riuscita",
        "Password changed successfully": "Password modificata correttamente",
        "The file to upload is larger than 100 MB。 Please select another one。": "Il file di caricamento è più grande di 100 MB. Selezionane un altro.",
        "Your session has expired。 Please log in again。": "La sessione è scaduta. Effettuare nuovamente l'accesso.",
        "Invalid network request URL": "URL della richiesta di rete non valido.",
        "Unknown server error": "Si è verificato un errore sconosciuto.",
        "An unknown error has occurred": "Si è verificato un errore sconosciuto!",
        "Request timeout。 Please check your network and try again。": "Richiesta scaduta. Controllare la rete e riprovare.",
        "Failed to connect to server": "Impossibile connettersi al server",
        "Your network may be currently disconnected": "La rete potrebbe essere attualmente disconnessa",
        "No related device found": "Nessun dispositivo trovato",
        "Pre-upgrade component not found in the device": "Componente pre-aggiornato non trovato nel dispositivo",
        "FWID of the installation component not found": "Componente di installazione FWID non trovato",
        "Failed to set upgrade information": "Impostazioni di aggiornamento delle informazioni non riuscite",
        "Failed to set specified update options": "Impossibile specificare le impostazioni dell'aggiornamento",
        "Failed to install the update package": "L'installazione del pacchetto di aggiornamento non è riuscita",
        "Failed to obtain the device handle": "Impossibile recuperare la maniglia del dispositivo",
        "Upgrade device mismatch": "Dispositivo di aggiornamento non corrispondente",
        "Installation failed: Pre-upgrade component not found in the device": "Impossibile installare: non sono stati trovati componenti pre-aggiornati nel dispositivo",
        "Installation failed: FWID mismatch in the component list": "Impossibile installare: FWID non corrispondente nel componente",
        "Installation failed: No matching monitor found for upgrade": "Impossibile installare: non è stato trovato un monitor corrispondente all'aggiornamento",
        "The monitor does not exist": "Il monitor non esiste",
        "The command has been sent": "Il comando è stato inviato",
        "The group does not exist": "Il gruppo non esiste",
        "The command does not exist": "Il comando non esiste",
        "Setting does not exist": "Impostazioni non esistenti",
        "The settings profile does not exist": "Il profilo delle impostazioni non esiste",
        "The update package does not exist": "Il pacchetto di aggiornamento non esiste",
        "The update package record does not exist": "Il record del pacchetto di aggiornamento non esiste",
        "Invalid password format。 It must be between 8 and 30 characters long。": "Formato password non valido. Deve avere una lunghezza compresa tra 8 e 30 caratteri.",
        "Password format is incorrect， password must include at least three types of the following: uppercase letters， lowercase letters， digits， and special characters": "La password non è formattata correttamente e contiene almeno tre tipi di lettere maiuscole, minuscole, numeri e caratteri speciali",
        "The field is empty": "Il campo è vuoto",
        "Update time cannot be null": "Il tempo di aggiornamento non può essere vuoto",
        "Invalid update time。 It cannot be earlier than the current time or more than 30 days in the future。": "Ora di aggiornamento non valida. Non può essere precedente all'ora corrente o più di 30 giorni nel futuro.",
        "Uploaded file is null": "Il file caricato è vuoto",
        "Uploaded file format is incorrect， file format can only be zip/exe/dmg/app": "Il formato del file caricato non è corretto e può essere solo zip/exe/dmg/app",
        "Uploaded file format is incorrect， file cannot have no extension": "Il formato del file caricato non è corretto e il file non può essere caricato senza suffisso",
        "Login failed。 Make sure you entered the correct account ID and password。": "Accesso non riuscito. Assicurarsi di aver immesso l'ID account e la password corretti.",
        "Date": "la data",
        "Time": "l'ora",
        "The data will be permanently deleted": "Questa operazione eliminerà permanentemente i dati correnti, se continuare?",
        "Please select an item to delete first": "Seleziona un elemento prima di rimuoverlo",
        "Select an item and then delete":"Selezionare un elemento, quindi eliminarlo",
        "Begin Download": "Inizia il download",
        "Start Download":"Avvia download",
        "Password incorrect": "Password non corretta",
        "Password Changed Successfully": "Password modificata con successo",
        "Display ID or Group ID is empty": "ID del display o ID del gruppo vuoto",
        "Select the update package": "Seleziona il pacchetto di aggiornamento",
        "Username already exists": "Il nome utente esiste già",
        "Executing monitor setting command。Please wait 10s before making new changes。": "Il comando di impostazione del monitor è in esecuzione, aspettare 10s prima di effettuare una nuova impostazione",
        "Close": "Off",
        "Role does not exist。 Cannot modify role。": "Il ruolo non esiste, non è possibile modificarlo",
        "Unknown Command": "Comando sconosciuto",
        "Access Token Expired": "Il token di accesso è scaduto",
        "Invalid Refresh Token": "Token di aggiornamento non valido",
        "Missing Request Parameters:": "Parametri di richiesta mancanti:",
        "Incorrect Request Parameter Type:": "Tipo di parametro di richiesta sbagliato:",
        "Request URL Not Found:": "The requested address does not exist:",
        "Incorrect Request Method:": "The request method is incorrect:",
        "Log In": "Accedi",
        "account ID": "ID account",
        "password": "password",
        "Update failed": "Aggiornamento non riuscito",
        "Reset Password?": "Reimposta password",
        "Logged in successfully": "Accesso effettuato correttamente",
        "Please contact the system administrator to reset your password": "Contattare l'amministratore di sistema per reimpostare la password.",
        "Retry limit exceeded。 Please try again after 30 minutes": "Limite di riprova superato. Si prega di riprovare dopo 30 minuti",
        "Enter the model / host name / firmware version number": "Immettere il modello/nome host/numero di versione del firmware",
        "New Group": "Nuovo gruppo",
        "Delete Group": "Elimina gruppo",
        "Display Columns": "Visualizza colonne",
        "Collapse": "Comprimi",
        "Expand": "Espandi",
        "Move To": "Sposta in",
        "Export": "Esportazione",
        "Power On": "Accensione",
        "Power Off": "Spegnimento",
        "Screen lock": "Blocco schermo",
        "Unlock screen": "Sblocca schermo",
        "Settings": "Impostazioni",
        "Export Settings Profiles": "Esporta profili di impostazioni",
        "Update": "Aggiorna",
        "Delete Monitor": "Elimina monitor",
        "Total devices": "Dispositivi totali",
        "Selected devices": "Dispositivi selezionati",
        "Update package name": "Nome del pacchetto di aggiornamento",
        "Update Time": "Ora di aggiornamento",
        "Apply to all displays of the same model": "应用于同型号显示器",
        "Display Settings": "Impostazioni schermo",
        "Select All": "Seleziona tutto",
        "Settings Profiles": "Profili di impostazioni",
        "Filename": "Nome del file",
        "Group": "Gruppo",
        "Monitor Model": "Modello di monitor",
        "Special ID": "ID speciale",
        "Host Name": "Nome host",
        "Host Status": "Stato host",
        "Monitor Status": "Stato del monitor",
        "Lock Status": "Stato di blocco",
        "Update Progress": "Avanzamento dell'aggiornamento",
        "Settings Profile": "Impostazione del profilo",
        "Tips": "Suggerimenti",
        "Active Time": "Tempo di attività",
        "Overclock": "sovrafrequenza",
        "Operation successful": "Operazione riuscita",
        "Please save data": "Salvare i dati",
        "Select the data first": "Seleziona prima i dati",
        "Cannot modify when ungrouped": "Impossibile modificare quando non è raggruppato",
        "Deselect All": "Deseleziona tutto",
        "Select the GAMMA node label value": "Selezionare il valore dell'etichetta del nodo GAMMA",
        "Ungrouped": "Non raggruppato",
        "Offline": "Offline",
        "Online": "Online",
        "Power on": "Avvia",
        "Power off": "Spegni",
        "Locked": "Bloccato",
        "Open": "Non bloccato",
        "Open": "Sbloccato",
        "Unlocked":"Sbloccato",
        "Not connected": "Non connesso",
        "Connected": "Connessione",
        "Set the update start time": "Impostare l'ora di inizio dell'aggiornamento",
        "Now": "Ora",
        "Set upgrade mode": "Impostare la modalità di aggiornamento",
        "Interactive Mode": "Modalità interattiva",
        "Silent mode": "Modalità silenziosa",
        "In this mode， a monitor firmware update screen will appear and request users confirmation to proceed! Users may choose to postpone the update twice, after which the update will be enforced": "In questa modalità, verrà visualizzata una schermata di aggiornamento del firmware del monitor e verrà richiesta la conferma dell'utente per procedere. Gli utenti possono scegliere di posticipare l'aggiornamento due volte, dopodiché l'aggiornamento verrà applicato.",
        "Invalid input": "Input non valido",
        "Failed to log in": "Accesso non riuscito",
        "Select your preferred restart time。": "Selezionare l'ora di riavvio preferita in base all'utilizzo.",
        "You have still selected the group that the device currently belongs to。 If you want to move the device， please select another group。": "Fai clic sul gruppo in cui il tuo dispositivo appartiene attualmente. Per spostarlo, seleziona un altro gruppo.",
        "Enter the group name": "Immettere il nome del gruppo",
        "Apply profile:": "Applica profilo:",
        "A new version is available": "È disponibile una nuova versione",
        "Restart monitor immediately after update": "Riavvia il monitor immediatamente dopo l'aggiornamento",
        "Restart when the monitor enters sleep mode": "Riavviare quando il monitor entra in modalità sospensione",
        "Restart monitor when it disconnected from all PCs": "Riavviare quando il monitor è disconnesso e tutti i PC connessi",
        "Enter the model name": "Immettere il nome del modello",
        "Create Update Task": "Crea attività di aggiornamento",
        "Update Task List": "Aggiorna elenco attività",
        "Cancel All": "Annulla tutto",
        "View Details": "Visualizza dettagli",
        "Update Details": "Aggiorna dettagli",
        "Update Mode": "Modalità di aggiornamento",
        "Update Creation Time": "Ora di creazione dell'aggiornamento",
        "Update Start Time": "Ora di inizio aggiornamento",
        "Are you sure you want to cancel all tasks?": "Annullare tutte le attività?",
        "Are you sure you want to cancel this task?": "Desideri annullare questa missione?",
        "Are you sure you want to delete the selected monitor?": "Eliminare il monitor selezionato?",
        "Confirm to delete all displays?": "Siete sicuri di voler eliminare tutti i monitor?",
        "Are you sure you want to delete this？（Cannot delete when ungrouped）": "Eliminarlo? (Impossibile eliminare se non raggruppato)",
        "Tip: If an option in the display settings appears grayed out， it may be restricted by another setting。 Try adjusting other settings to remove the restriction。": "Suggerimento: se un'opzione nelle impostazioni schermo appare disattivata, potrebbe essere limitata da un'altra impostazione. Provare a regolare altre impostazioni per rimuovere la restrizione.",
        "The WebSocket connection has been restored": "La connessione WebSocket è stata ripristinata.",
        "The previous setting is currently being applied。 Please wait until the value changes before making any new settings。": "L'impostazione precedente è in esecuzione, aspettate che i valori cambino prima di effettuare una nuova impostazione",
        "Please copy this password into the input box: ": "Copiare questa password nella casella di immissione: ",
        "Ebook": "Ebook",
        "largest": "più grande",
        "Max":"Máxima",
        "Turn off auto mode": "Disattiva la modalità automatica",
        "Minimum": "Minimo",
        "Restore Factory Settings": "Ripristina impostazioni predefinite",
        "Scenario Mode": "Modalità scenario",
        "Color Gamut & Color Temperature": "Gamma di colori e temperatura del colore",
        "Panel Native": "Pannello nativo",
        "Neutral": "Neutro",
        "Close PIP, PBP":"Chiudi",
        "PIP window":"PIP",
        "PBP window":"PBP",
        "Neutral(7500K)":"Neutro",
        "Reddish(6500K)":"Caldo",
        "Bluish(9300K)":"Freddo",
        "Warm": "Caldo",
        "Cool": "Freddo",
        "Low Blue Light": "Luce blu bassa",
        "Custom 1": "Personalizzato 1",
        "Custom 2": "Personalizzato 2",
        "Custom 3": "Personalizzato 3",
        "BT.709": "BT.709",
        "BT.2020": "BT.2020",
        "Video Signal": "Segnale video",
        "Game Mode": "Modalità di gioco",
        "Off": "Chiudi",
        "Game 1": "Gioco 1",
        "Game 2": "Gioco 2",
        "Response Time": "Tempo di risposta",
        "Normal": "Normale",
        "Extreme": "Estremo",
        "Level 1": "Livello 1",
        "Level 2": "Livello 2",
        "Level 3": "Livello 3",
        "Level 4": "Livello 4",
        "Level 5": "Livello 5",
        "Lan Indicator": "Indicatore LAN",
        "Linked": "Connesso",
        "No Link": "Disconnesso",
        "Blinking": "Lampeggiando",
        "Brightness": "Luminosità",
        "Contrast": "Contrasto",
        "Smart Light": "Luminosità intelligente",
        "Volume Control": "Controllo del volume",
        "USB Select": "Selezione USB",
        "DP Select": "Selezione DP",
        "Aspect Ratio": "Proporzioni",
        "Smart Traffic Light": "Semaforo smart",
        "daisy chain": "Daisy-chain",
        "Dynamic Contrast": "Contrasto dinamico",
        "Smart Energy": "Energia smart",
        "Smart Audio": "Audio Smart",
        "Distance Warning": "Avviso distanza",
        "Ambient Light Detection": "Rilevamento luce ambientale",
        "Enabled Ambient Light Detection": "Abilita Rilevamento luce ambientale",
        "enabled":"enabled",
        "disabled":"disabled",
        "Waken on Touch": "Interrutore tattile",
        "True Split": "Schermo diviso",
        "Face Tracking": "Tracciamento con il riconosciamento facciale",
        "Audio Smart Switch": "Interruttore audio intelligente",
        "Auto-alarm": "Allarme automatico",
        "KVM Switch": "Interruttore KVM",
        "KVM切换": "Interruttore KVM",
        "KVM(Keyboard, Video, Mouse) Switch enables two PCs to use one set of monitor, keyboard and mouse, Enable switching video, keyboard and mouse simultaneously. If disabled, only switch keyboard and mouse.": "L'interruttore KVM (tastiera, video, mouse) consente a due PC di utilizzare un set di monitor, tastiera e mouse, Abilita la commutazione simultanea di video, tastiera e mouse. Se disabilitato, cambia solo tastiera e mouse",
        "Sitting Reminder": "Promemoria seduta",
        "Gaming": "Gioco",
        "RGB Gain": "Regolazione del colore",
        "Serial No": "Numero di serie",
        "Firmware Version": "Versione firmware",
        "Select response time level": "Seleziona il livello del tempo di risposta",
        "Enable daisy chain": "Abilita daisy-chain",
        "Smart Traffic Light is a do not disturb light, helping to reduce distraction": "Semaforo smart è una luce non disturbare, che aiuta a ridurre la distrazione",
        "Enable/Disable the Audio Smart function": "Abilita/disabilita audio intelligente",
        "Auto-alarm indicates whether the camera/MIC on monitor is in use": "Indicatore d'allarme automatico nel caso camera/MIIC sia attiva sullo schermo",
        "Enable Distance Warning": "Abilita Avviso distanza",
        "Enable/disable face tracking": "Apri/chiudi tracciamento con il riconosciamento facciale",
        "Enable Sitting Reminder": "Abilita Promemoria seduta",
        "Smart Audio technology allows you to focus on the sound in front of you to improve voice clarity": "La tecnologia Audio Smart ti consente di concentrarti sul suono di fronte a te per migliorare la chiarezza della voce",
        "Smart Energy technology automatically manages energy consumption by human detection sensor": "La tecnologia Energia Smart gestisce automaticamente il consumo di energia dal sensore di rilevamento umano",
        "Implement PBP through only one cable": "Implementa PBP tramite un solo cavo",
        "Enable/Disable vPro technology in the monitor": "Abilita/disabilita vPro tecnologia sullo schermo",
        "Wake system by touch": "Attiva sistema con un tocco",
        "Set video source and USB source (used by keyboard and mouse) for every PC": "Imposta la sorgente video e la sorgente USB (utilizzata da tastiera e mouse) per ogni PC",
        "eKVM gives you instant access over two PC sources with a 2-button pressing of your mouse": "eKVM ti dà accesso istantaneo a due sorgenti di PC con un doppio clic del mouse",
        "Enable USB charging always on": "Abilita la ricarica USB sempre attiva",
        "Select DP version": "Selezionare DP versione",
        "USB Charging": "Carica USB",
        "PC": "PC",
        "Double-click the CTRL": "Fare doppio clic su CTRL",
        "Full Screen": "Schermo intero",
        "Original AR": "AR originale",
        "No scaling": "Nessuna ridimensionamento",
        "on": "Apri",
        "On": "Apri",
        "Keyboard On": "Tastiera accesso",
        "Mouse On": "Mouse accesso",
        "Image Creation": "Creazione di immagini",
        "Digital Cinema": "Cinema digitale",
        "Video Creation": "Creazione video",
        "Web Browsing": "Navigare su Internet",
        "Professional Image": "Immagine professionale",
        "DisplayPort": "DisplayPort",
        "Auto": "Modalità automatica",
        "Refresh": "Aggiorna",
        "Search": "Cerca",
        "Record": "Registrazione",
        "Username": "Nome utente",
        "Upload Time": "Tempo di caricamento",
        "Add Profiles": "Aggiungi profili",
        "Latest Update Package": "Pacchetto di aggiornamento più recente",
        "Upload Update Package": "Carica pacchetto di aggiornamento",
        "Upload": "Carica",
        "Size": "Dimensioni",
        "Upload successful": "Caricamento riuscito",
        "Download successful": "Download completato",
        "Refresh successful": "Aggiornamento riuscito",
        "The upgrade package does not match the device model": "Pacchetto di aggiornamento non corrispondente al modello",
        "Upgrade package does not match the device model":"Il pacchetto di aggiornamento non corrisponde al modello del dispositivo",
        "Please enter the setting name": "Inserisci il nome dell'impostazione",
        "Edit": "Modifica",
        "Save": "Salva",
        "Delete": "Elimina",
        "Add": "Aggiungi",
        "Reset Password": "Reimposta password",
        "No": "N.",
        "Full Name": "Nome e cognome",
        "Role": "Ruolo",
        "Creation Date": "Data di creazione",
        "Operation": "Operazione",
        "Actions": "Operazione",
        "The user's initial password is ": "该用户的初始密码为 ",
        "The password has been reset to：": "La password è stata reimpostata su: ",
        "Invalid input。Usernames can only contain numbers and letters。": "Input non valido. Il nome utente è composto da numeri e lettere.",
        "Invalid input。The username must contain 4 to 30 characters。": "Input non valido. Il nome utente deve contenere da 4 a 30 caratteri.",
        "Installation Package": "Pacchetto di installazione",
        "Operation Date": "Data dell'operazione",
        "Actions": "Azioni",
        "Operator": "Operatore",
        "Paging component": "Componente Paging",
        "Quick page flipping": "Flipping rapido della pagina",
        "Current page": "Pagina corrente",
        "Title": "Titolo",
        "Details": "Dettagli",
        "This is the expanded area": "Questa è l'area espansa",
        "Set Display Column": "Impostare colonna di visualizzazione",
        "Upload file": "Carica file",
        "Drop-down to expand": "Drop-down to expand",
        "Default": "Default",
        "Default Info": "Informazioni predefinite",
        "Personal Center": "Centro personale",
        "Personal center image button": "Personal center image button",
        "Expandable area": "Area espandibile",
        "Update Package Table": "Aggiornare la tabella dei pacchetti",
        "This is the table header": "This is the table header",
        "This is the table content": "Questo è il contenuto della tabella",
        "UserList Table": "Tabella della Lista Utenti",
        "Page Up and Down": "Pagina su e giù",
        "Operation record table": "Tabella del registro dell'operazione",
        "OSD upgrade details": "Dettagli dell'aggiornamento OSD",
        "Lenovo": "Lenovo",
        "Display Fleet Manager": "Display Fleet Manager",
        "HDR": "HDR",
        "eKVM": "eKVM",
        "Video": "Video",
        "Data": "Data",
        "vPro": "vPro",
        "Gama": "Gama",
        "PIP/PBP": "PIP/PBP",
        "OSD": "OSD",
        "USB-C Charging": "Ricarica USB-C",
        "PIP": "PIP",
        "PBP": "PBP",
        /*
        "Simplified Chinese": "Cinese semplificato",
        "English": "Inglese",
        "Traditional Chinese": "Cinese tradizionale",
        "French": "francese",
        "German": "tedesco",
        "Italian": "Italiano",
        "Spanish": "Spagnolo",
        "Japanese": "Giapponese",
        "Thai": "Thailandese",
        "Ukrainian": "Lingua ucraina",
        "Russian": "russo",
        */
        "Enter your account ID": "Inserisci l'ID del tuo account",
        "Please Enter your account id":"Contattare l'amministratore di sistema per reimpostare la password.",
        "Enter your password": "Inserisci la tua password",
        "Cannot exceed 20 characters": "Non può superare i 20 caratteri",
        "Enter the original password": "Inserire la password originale",
        "You have still selected the group that the device currently belongs to. If you want to move the device, please select another group. ": "È stato comunque selezionato il gruppo a cui il dispositivo appartiene attualmente. Se si desidera spostare il dispositivo, selezionare un altro gruppo. ",
        "Enter the filename": "Immettere il nome del file",
        "Update Package Name": "Nome del pacchetto di aggiornamento",
        "Select the date": "Seleziona la data",
        "Select the time": "Seleziona l'ora",
        "Set the update mode": "Imposta modalità di aggiornamento",
        "Restart when the monitor is not connected to any computer": "Riavviare quando il monitor non è collegato ad alcun computer",
        "Invalid file format": "Formato file non valido. Sono supportati solo i file zip/exe/dmg/app.",
        "Select a valid file type": "Selezionare un tipo di file valido",

        "The data is being processed。 Please do not submit again。": "I dati sono in fase di elaborazione. Non inviare di nuovo.",
        "Enter the profiles name": "Inserire il nome del profilo",
        "Enter your username": "Inserisci il tuo nome utente",
        "Enter your full name": "Inserisci il tuo nome e cognome",
        "The initial password of this user is:": "La password iniziale di questo utente è: ",
        "Select your role": "Seleziona il tuo ruolo",
        "User Profile": "Profilo utente",
        "Downloading": "Scarica...",
        "Enter the new password again。Two times of new password input is same": "Immettere nuovamente la nuova password.La nuova password deve corrispondere a quella precedente.",
        "Request failed with status code 502": "Richiesta non riuscita con codice di stato 502",
        "Please Enter your x": "Immetti {param}",
        "Select the x": "Seleziona {param}",
        "Please select the correct file type x": "Selezionare un tipo di file valido {param}",
        "Please select the correct file type": "Selezionare un tipo di file valido",
        "Input characters within x characters": "Inserisci caratteri in meno di {param} caratteri",

        "Monitor List":"Elenco monitor",
        "List of update packages":"Elenco dei pacchetti di aggiornamento",
        "Update Package":"Pacchetto di aggiornamento",
        "Settings - Profiles":"Impostazioni - Profili",
        "User Management":"Gestione utenti",
      

        "Simplified Chinese": "简体中文",
        "English": "English",
        "Traditional Chinese": "繁體中文",
        "French": "Français",
        "German": "Deutsch",
        "Italian": "Italiano",
        "Spanish": "Español",
        "Japanese": "日本語",
        "Thai": "ภาษาไทย",
        "Ukrainian": "Українська",
        "Russian": "Русский язык",

        "System abnormality":"Anomalia del sistema",

        "Upgrade Package Record ID is empty":"Seleziona il pacchetto di aggiornamento",

        "In this mode， when the monitor is online， the firmware update will be automatically performed in the background。 Users will not see any notifications。 The update will take effect when the display is restarted。 The restart of the monitor takes about a few seconds， and won’t affect any ongoing tasks on your computer。": "in diesem Modus wird die Firmware-Aktualisierung automatisch im Hintergrund durchgeführt, sobald der Monitor online ist. Den Benutzern werden keine Benachrichtigungen angezeigt. Die Aktualisierung wird wirksam, wenn der Monitor neu gestartet wird. Der Neustart des Monitors dauert einige Sekunden und hat keine Auswirkungen auf laufende Aufgaben auf Ihrem Computer.Wählen Sie den bevorzugten Zeitpunkt für den Neustart im Einklang mit Ihrer Nutzung aus.",
        "Invalid update time。 It cannot be earlier than the current time or more than 30 days in the future。":"Orario di aggiornamento non valido. Non può essere prima dell'ora attuale o più di 30 giorni in futuro.",
      
        "Request parameter is invalid:The username must contain 4 to 30 characters。":"Parametro di richiesta non valido:Il nome utente deve contenere da 4 a 30 caratteri.",
        "The WebSocket connection has been lost Reconnecting":"La connessione WebSocket è stata persa",
        "Request parameter is invalid：Usernames can only contain numbers and letters。":"Parametro di richiesta non valido:Il nome utente è composto da numeri e lettere.",

        "Request parameter is invalid:Password length must be between 8-16 character":"Il parametro di richiesta non è valido: la lunghezza della password deve essere compresa tra 8 e 16 caratteri.",
        "The compiled package is missing: the component has a corresponding bin that has not been uploaded。Please upload it before compiling":"Manca il pacchetto compilato: il componente ha un contenitore corrispondente che non è stato caricato. Si prega di caricarlo prima di compilarlo.",

        "Request parameter is invalid：Password length must be 8–16 characters":"Il parametro di richiesta non è valido: la lunghezza della password deve essere compresa tra 8 e 16 caratteri",


        "Illegal request header!": "Intestazione della richiesta illegale!",
        "Invalid request parameters":"Parametri di richiesta non validi",
        "Export": "Esporta",
        "It is already a high-version and there is no need to upgrade":"È già una versione alta e non c'è bisogno di aggiornare",
        "Repeated request， please try again later":"Richiesta ripetuta, riprova più tardi",
        "Communication":'Comunicazione',
    }
}